import { deleteCategoria, getCategoriasPanel} from "../../services/CategoriasClienteServices";
import { CategoriasClienteContext } from "./CategoriasClienteContext"

export const CategoriasClienteState = ({ children }) => {
    const getCategoriasClientePanelData = async (searchTerm,numPagina, filas) => {
        let res = await getCategoriasPanel(searchTerm,numPagina, filas);
        return res;
    }
 
    const deleteCategoriaClienteData = async (body) => {
        const res = await deleteCategoria(body)
        if (res) getCategoriasClientePanelData()
        return res
    }

    return <CategoriasClienteContext.Provider value={{
        deleteCategoriaClienteData,
        getCategoriasClientePanelData,
    }} >
        {children}
    </CategoriasClienteContext.Provider>
}